export default __webpack_public_path__ + "static/media/fig.c5802368.png";